export interface ValueStackCard {
  icon: 'book' | 'calendar' | 'check'
  title: string
  description: string
}

export const valueStack: ValueStackCard[] = [
  {
    icon: 'book',
    title: 'El Ebook Maestro',
    description: '60 páginas de ciencia aplicada y protocolos paso a paso.',
  },
  {
    icon: 'calendar',
    title: 'El Mapa de 21 Días',
    description: 'Tu guía diaria para pasar de la fatiga a la vitalidad total.',
  },
  {
    icon: 'check',
    title: 'Checklists de Escenario',
    description: 'Qué comer en restaurantes, eventos y viajes.',
  },
]

export type PillarVisual = 'curve' | 'shield' | 'plate' | 'scenarios' | 'cycle' | 'calendar'

export interface Pillar {
  number: string
  title: string
  copy: string
  visual: PillarVisual
  core?: boolean
}

export const pillars: Pillar[] = [
  {
    number: '01',
    title: 'El Despertar Metabólico',
    copy: 'Aprende a leer los mensajes de tu cuerpo y sal de la trampa de las calorías.',
    visual: 'curve',
  },
  {
    number: '02',
    title: 'La Ciencia del Escudo',
    copy: 'Descubre cómo la fibra, la proteína y la grasa actúan como guardaespaldas de tu salud.',
    visual: 'shield',
  },
  {
    number: '03',
    title: 'El Código 1-2-3',
    copy: 'El orden de los factores sí altera el producto. Reduce tus picos hasta un 75% solo cambiando el orden de tus bocados.',
    visual: 'plate',
    core: true,
  },
  {
    number: '04',
    title: 'Protocolos de Vida Real',
    copy: 'Cómo hackear el menú de cualquier restaurante y disfrutar del alcohol sin arruinar tu progreso.',
    visual: 'scenarios',
  },
  {
    number: '05',
    title: 'Biohacking Femenino',
    copy: 'Usa tu ciclo a tu favor y descubre el truco del vinagre para aplanar curvas en 60 segundos.',
    visual: 'cycle',
  },
  {
    number: '06',
    title: 'El Mapa de 21 Días',
    copy: 'Tu plan de vuelo día a día para que la estabilidad sea tu nueva normalidad.',
    visual: 'calendar',
  },
]

export interface MythRow {
  myth: string
  reality: string
}

export const myths: MythRow[] = [
  {
    myth: 'Todas las calorías son iguales.',
    reality: 'Las hormonas mandan: 300 calorías de pan y 300 de salmón hacen cosas opuestas.',
  },
  {
    myth: 'Desayunar con zumo de naranja es saludable.',
    reality: 'El zumo es azúcar puro sin fibra: el pico más grande de tu día.',
  },
  {
    myth: 'La grasa es el enemigo.',
    reality: 'La grasa estabiliza: frena la absorción del azúcar y te sostiene la saciedad.',
  },
  {
    myth: 'Si tienes antojos, te falta voluntad.',
    reality: 'El antojo es una caída de glucosa. Es una señal biológica, no un defecto tuyo.',
  },
  {
    myth: 'Hay que comer menos y moverse más.',
    reality: 'Si la insulina está alta, tu cuerpo no puede usar la grasa que ya tiene guardada.',
  },
]

export const bodySignals: { signal: string; meaning: string }[] = [
  { signal: 'Antojo', meaning: 'glucosa baja' },
  { signal: 'Fatiga después de comer', meaning: 'pico de insulina' },
  { signal: 'Peso estancado', meaning: 'insulina crónica' },
]
